import React from "react";
import { Form, Select, Tag } from "antd";
import type { SelectProps } from "antd";

import { ISelectOption } from "shared/models";
import { Rule } from "antd/es/form";
import { SizeType } from "antd/es/config-provider/SizeContext";

type TagRender = SelectProps["tagRender"];

type Props = {
  placeHolder?: string;
  options: ISelectOption[];
  name: string;
  label: React.ReactNode;
  rules?: Rule[];
  minWidth?: number;
  testId?: string;
  size?: SizeType;
};

export const tagRender: TagRender = (props) => {
  const { label, closable, onClose } = props;
  const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      color='#13b76e'
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginInlineEnd: 4 }}
    >
      {label}
    </Tag>
  );
};

export const MultiSelectBox = ({
  placeHolder = "Select...",
  options,
  name,
  label,
  rules,
  minWidth = 200,
  testId,
  size,
}: Props) => (
  <Form.Item name={name} label={label} rules={rules} data-testid={testId}>
    <Select
      mode='multiple'
      tagRender={tagRender}
      className='multi-select-box'
      placeholder={placeHolder}
      style={{ minWidth }}
      size={size}
      showSearch
      filterOption={(input, option) =>
        String(option?.children ?? "")
          .toLowerCase()
          .includes(input.toLowerCase())
      }
    >
      {options.map((opt, idx) => (
        <Select.Option
          key={`${testId}-option-${idx}`}
          value={opt.value}
          data-testid={`${testId}-option-${idx}`}
        >
          {opt.label}
        </Select.Option>
      ))}
    </Select>
  </Form.Item>
);
